import {
  createPlanAlertStorage,
  defaultStorageAdapter,
  type StorageAdapter,
} from './createPlanAlertStorage';

interface PlanStartState {
  shown?: boolean;
}

/**
 * 플랜 시작 알림 스토리지 팩토리 함수
 */
export function createPlanStartAlertStorage(
  storage: StorageAdapter = defaultStorageAdapter,
) {
  const alertStorage = createPlanAlertStorage<PlanStartState>(
    'plan-start-modal',
    storage,
  );

  return {
    /**
     * 모달을 표시해야 하는지 확인합니다.
     */
    shouldShowModal(): boolean {
      return !alertStorage.getState().shown;
    },

    /**
     * 시작 모달을 표시했다고 표시합니다.
     */
    markAsShown(): void {
      alertStorage.setState({ shown: true });
    },

    /**
     * 스토리지 초기화
     */
    reset(): void {
      alertStorage.reset();
    },
  };
}

/** 싱글톤 인스턴스 */
export const planStartAlertStorage = createPlanStartAlertStorage();
